"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
function view() {
    var _this = this;
    return {
        state: {
            hasBannerImg: (this.props.bannerImageUrl.length > 0),
            customFieldDropdownMultiselectButtonTextSuffix: csod.locales.get("ATS.CareerSite.MainSearch.MultiSelectedText", "fields selected"),
            customFieldDropdownPlaceholderText: "Test placeholder",
            customFieldDropdownItems: [
                {
                    label: 'item1',
                    value: 'value1',
                    isChecked: false,
                },
                {
                    label: 'item2',
                    value: 'value2',
                    isChecked: false,
                },
                {
                    label: 'item3',
                    value: 'value3',
                    isChecked: false,
                }
            ],
            isCustomFieldDropdownMultiselect: false,
            customFieldDropdownHeight: "200px",
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                _this.view.state.isCustomFieldDropdownMultiselect = nextProps.isCustomFieldDropdownMultiselect;
                _this.view.state.customFieldDropdownPlaceholderText = nextProps.cfMainSearchDropdownTitle;
                _this.view.state.customFieldDropdownItems = nextProps.cfMainSearchDropDownOptions;
                _this.view.state.hasBannerImg = (nextProps.bannerImageUrl.length > 0);
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onSearchClick: this.props.onSearchClick,
            onLocationSearch: this.props.onLocationSearch,
            onLocationSearchChange: this.props.onLocationSearchChange,
            onLocationSearchPredict: this.props.onLocationSearchPredict,
            onLocationSearchSelect: this.props.onLocationSearchSelect,
            onKeywordSearch: this.props.onKeywordSearch,
            onKeywordSearchChange: this.props.onKeywordSearchChange,
            onKeywordSearchPredict: this.props.onKeywordSearchPredict,
            onKeywordSearchSelect: this.props.onKeywordSearchSelect,
            onOpenFilterFlyout: this.props.onOpenFilterFlyout,
            setContentHeight: this.props.setContentHeight,
            onCustomFieldDropdownChange: this.props.onCFMainSearchDropdownChange
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobSearchBanner/View.js
// module id = 423
// module chunks = 0